// extracted by mini-css-extract-plugin
module.exports = {"loader":"style__loader__ATCK3","load":"style__load__0uub7"};